












































































































































































































































































































































































































































































































































import {
    Component,
    Emit,
    Inject,
    Model,
    Prop,
    Provide,
    Vue,
    Watch,
} from 'vue-property-decorator';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
import * as mainImg from '@/importImage/main';
import * as homeImg from '@/importImage/home';
/* component组件 */
@Component({
    components: {},
})
export default class Home extends Vue {
    /* @Inject/@Prop */

    /* data数据 /@Provide */
    mainImg: any = mainImg;
    homeImg: any = homeImg;
    height: number = 0;

    list1: Array<any> = [
        {
            icon: 'icon-weixiu',
            title: '建筑消防维护保养',
            des: 'MAINTENANCE OF BUILDING<br/>FIRE PROTECTION',
        },
        {
            icon: 'icon-jiance',
            title: '建筑消防设施检测',
            des: 'DETECTION OF BUILDING FIRE<br/>FIGHTING FACILITIES',
        },
        {
            icon: 'icon-gongcheng',
            title: '建筑消防工程',
            des: 'BUILDING FIRE PROTECTION<br/>ENGINEERING',
        },
    ];
    list2: Array<any> = [
        {
            icon: 'icon-guwen',
            title: '贴身顾问',
            des: 'PERSONAL ADVISER',
        },
        {
            icon: 'icon-gaoxiao',
            title: '高效快捷',
            des: 'EFFICIENT AND FAST',
        },
        {
            icon: 'icon-peixun',
            title: '人员培训',
            des: 'SRAFF TRAINING',
        },
    ];
    /* method/@Emit/@Action/@Mutation */

    /* computed/@State/@Getter */

    /* Watch监听 */
    /* @Watch('xxx') */
    /* @Watch('xxx', { deep: true }) */

    /* lifecycle 生命周期 */
    created() {
        this.height = Math.max(document.body.clientHeight, 700);
        (window as any).onresize = () => {
            this.height = Math.max(document.body.clientHeight, 700);
        };
    }
    mounted() {}
}
